import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@spotnana/pixel-react/dist/Box';
import * as Icons from '@spotnana/pixel-react/dist/Icons';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';
import { BookingPaymentSource, IUserOrgId, ListBookingPaymentSourcesRequestType } from 'obt-common';
import { AirInitiateBookingResponse } from 'obt-common/types/api/v1/obt/air/air_intitate_booking_response';
import { BookingWorkflowType } from 'obt-common/types/api/v2/obt/model/booking-workflow-type';
import { CheckoutTravelerInfo } from 'obt-common/types/api/v2/obt/model/checkout-traveler-info';
import Section from '../../flights/checkout/Section';
import PaymentOptions from '../payments/PaymentOptions';

interface CheckoutPaymentContainerProps {
  itineraryId: string;
  bookingType: ListBookingPaymentSourcesRequestType;
  onPaymentSourceSelect: (selectedPaymentSources: BookingPaymentSource[]) => void;
  selectedPaymentSourceIds: string[];
  primaryTravelerId: IUserOrgId;
  initiateOrderResponse?: AirInitiateBookingResponse;
  seatMapResponseId?: string;
  bookingWorkflowType: BookingWorkflowType;
  checkoutTravelerInfo?: CheckoutTravelerInfo;
  pnrId: string;
  tripId?: string;
}

const CheckoutPaymentContainer: FC<CheckoutPaymentContainerProps> = ({
  itineraryId,
  bookingType,
  onPaymentSourceSelect,
  selectedPaymentSourceIds,
  primaryTravelerId,
  initiateOrderResponse,
  seatMapResponseId,
  bookingWorkflowType,
  checkoutTravelerInfo,
  pnrId,
  tripId,
}) => {
  const { t: tt } = useTranslation('WEB');
  return (
    <Box>
      <Section
        heading={tt('Payment method')}
        icon={<Icons.PaymentMethod width="18" height="14" primaryColor={spotnanaTheme.colors.bg.dark} />}
        dataTestId="payment-section"
        styles={{ fontWeight: 600 }}
        // TODO: Should not hard code these styles with px
        iconStyles={{ marginRight: '24px', backgroundColor: spotnanaTheme.colors.bg.regular }}
        containerStyles={{ marginTop: '40px' }}
      />
      <PaymentOptions
        itineraryId={itineraryId}
        bookingType={bookingType}
        onPaymentSourceSelect={onPaymentSourceSelect}
        selectedPaymentSourceIds={selectedPaymentSourceIds}
        primaryTravelerId={primaryTravelerId}
        initiateOrderResponse={initiateOrderResponse}
        seatMapResponseId={seatMapResponseId}
        bookingWorkflowType={bookingWorkflowType}
        checkoutTravelerInfo={checkoutTravelerInfo}
        pnrId={pnrId}
        tripId={tripId}
      />
    </Box>
  );
};

export default CheckoutPaymentContainer;
